import React, { Component } from 'react';
import Menu from './menu/Menu';
import Cookies from 'universal-cookie';
import { apiD } from '../services/api';
import api from '../services/api';

export default class ListaArquivosRede extends Component {
  state = {
    arquivos: [],
    loading: false,
    erro: '',
    codfunc: '',
    codfilial: '',
  };


  async componentDidMount() {
    const cookies = new Cookies();
    let cpf = cookies.get('ckCPF');
    if (Array.isArray(cpf)) cpf = cpf[0];
    if (!cpf) {
      this.setState({ erro: 'CPF não encontrado no cookie.' });
      return;
    }
    try {
      // Busca dados do endpoint remoto
      const resp = await api.get(`/datasnap/rest/tsm/DadosEmpDom("${cpf}")`);
      const dados = resp.data.result[0][0];
      const codfunc = dados.i_empregados;
      const codfilial = dados.codi_emp;
      this.setState({ codfunc, codfilial }, () => {
        if (codfunc && codfilial) {
          this.buscarArquivos(codfunc, codfilial);
        }
      });
    } catch (e) {
      this.setState({ erro: 'Erro ao buscar dados do empregado: ' + (e.message || e) });
    }
  }

  buscarArquivos = async (codfunc, codfilial) => {
    this.setState({ loading: true, erro: '', arquivos: [] });
    try {
      // Chame o backend passando codfunc e codfilial usando apiD (axios)
      console.log('Buscando arquivos para codfunc:', codfunc, 'e codfilial:', codfilial);
      const resp = await apiD.get(`/api/lista-arquivos?codfunc=${codfunc}&codfilial=${codfilial}`);
      const data = resp.data;
      console.log('Arquivos recebidos do backend:', data);
      this.setState({ arquivos: data });
    } catch (e) {
      this.setState({ erro: e.message });
    }
    this.setState({ loading: false });
  };

  render() {
    const { arquivos, loading, erro } = this.state;
    return (
      <div className="principal">
        <div className="ListPed">
          <Menu />
          <p></p>
          <h2>Informe de Rendimentos</h2>
          {erro && <div style={{ color: 'red' }}>{erro}</div>}
          {loading && <div>Carregando...</div>}
          <table className="table table-hover table-striped table-dark align-middle">
            <thead>
              <tr>
                <th scope="col">Arquivo</th>
                <th scope="col">Download</th>
              </tr>
            </thead>
            <tbody>
              {arquivos.map((arq, idx) => (
                <tr key={idx}>
                  <td>{arq}</td>
                  <td>
                    <a href={`http://disnorteagil.no-ip.biz:8090/sistemas/download/InfoRendi//${arq}`} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm">Baixar</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
